<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <div contenido class="zonaClass">
    <div class="zonaBotones">
      <div style="padding: 10px 0;"><span> {{ 'gestion.reportes.planEs.elementosImprimir' | translate }} </span></div>
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.introduccion' | translate }}</span>
          <mat-slide-toggle id="st_introduccion" [(ngModel)]="imprimirIntro"></mat-slide-toggle>
        </div>
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.metodologia' | translate }}</span>
          <mat-slide-toggle id="st_metodologia" [(ngModel)]="imprimirMetodologia"></mat-slide-toggle>
        </div>
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.filosofia' | translate }}</span>
          <mat-slide-toggle id="st_filolosofia" [(ngModel)]="imprimirFilosofia"></mat-slide-toggle>
        </div>
        @if (verFodaV1) {
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.foda' | translate }}</span>
          <mat-slide-toggle id="st_foda" [(ngModel)]="imprimirFoda"></mat-slide-toggle>
        </div>
        }
        @if (verFodaV2) {
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.pestel' | translate }}</span>
          <mat-slide-toggle id="st_fodav2" [(ngModel)]="imprimirFodaV2"></mat-slide-toggle>
        </div>
        }
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.objetivos' | translate }}</span>
          <mat-slide-toggle id="st_objetivos" [(ngModel)]="imprimirObjetivos"></mat-slide-toggle>
        </div>
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.indicadores' | translate }}</span>
          <mat-slide-toggle id="st_indicadores" [(ngModel)]="imprimirIndicadores"></mat-slide-toggle>
        </div>
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.cmi' | translate }}</span>
          <mat-slide-toggle id="st_cmi" [(ngModel)]="imprimirCmi"></mat-slide-toggle>
        </div>
        <div class="togElement">
          <span>{{ 'gestion.reportes.planEs.planOperativo' | translate }}</span>
          <mat-slide-toggle id="st_planOperativo" [(ngModel)]="imprimirPlanOperativo"></mat-slide-toggle>
        </div>
    </div>
    <div class="zonaTextArea">
      <app-contenedor-elementos [header]="{
        title: 'gestion.reportes.planEs.introduccion' | translate
      }">
        <mat-accordion body class="bodyT">
          <mat-expansion-panel hideToggle expanded="true">
            
            <mat-form-field class="w3-input" style="border: none;">
              <textarea #txt_introduccion id="txt_introduccion" matInput cols="40" rows="17"
                [placeholder]="txt_introduccion.value === '' ? ('gestion.reportes.planEs.introduccionPlaceholder' | translate) : ''"></textarea>
            </mat-form-field>


            <mat-action-row>
              <button (click)="guardarIntroPlanificacion()" mat-button
                style="font-size: .8rem; float: right; background-color: #ED7D31; color: white;">{{
                'gestion.reportes.planEs.guardarIntroduccion' | translate }}</button>

            </mat-action-row>
          </mat-expansion-panel>
          <div style="float: right;">
            @if (isDownloadingPdf) {
            <div style="padding-top: 15px; font-size: .6rem; color: #808080;">{{
              'gestion.reportes.planEs.porFavorEspere' | translate }}</div>
            }

            @if (!isDownloadingPdf) {
            <button
              style="display: flex; flex-wrap: wrap; height: 50px; width: 100px; align-items: center; justify-content: center; background-color: transparent; border: none; cursor: pointer;"
              (click)="generarReporte()">
              <span style="font-size: .6rem; color: #808080;">{{ 'gestion.reportes.planEs.descargarReporte' |
                translate }}</span>
              <mat-icon style="font-size: 3rem; color: #ED7D31;">cloud_download</mat-icon>
            </button>
            }

          </div>
          <div id="floa_img_cont" style="display: none;">
            <img id="floa_img" #floa_img style="width: 500px;" src="assets/img/reportes/FODA.png" alt="">
          </div>
        </mat-accordion>
      </app-contenedor-elementos>
    </div>
  </div>
</app-esqueleto-tableros>